import React, { useEffect, useRef } from 'react';
import Navigation from './Navigation'
import "../App.css"
import { useNavigate } from 'react-router-dom';
import "./Com.css"

const Com = () => {

  const detailsContainersRef = useRef(null);
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {

    const detailsContainers = detailsContainersRef.current;

    // Start animations after a delay
    setTimeout(() => {
   
      detailsContainers.classList.add('slide-inn');
      document.body.classList.add('bg-white');

      // Slide out details container after a delay
      setTimeout(() => {
        detailsContainers.classList.add('slide-outt');

        // Redirect to /home after slide-out animation
        setTimeout(() => {
          navigate('/home'); // Correctly redirect to /home
        }, 1000);
      }, 10000);
          }, 3000);
  }, []);

    setTimeout(()=>{
        document.body.classList.add('bg-white');
      },100)
  return (
  <>
  <Navigation/>
  <div className="details-containers" ref={detailsContainersRef}>
        <h1>Launching Soon</h1>
      </div>
  </>
  )
}

export default Com